export default "__VITE_ASSET__uxNq5sUr__"